import axios from 'axios';
import { INoteCollectionDto, INoteListParams, INoteCreatePayload, INote } from 'entities/Notes/Note.models';

const basePath = '/notes';

export const noteService = {
  getNotes: (params: INoteListParams): Promise<INoteCollectionDto> => axios.get(`${basePath}`, { params }),
  createNote: (payload: INoteCreatePayload): Promise<INote> => axios.post(`${basePath}`, payload),
};
